// extracted by mini-css-extract-plugin
module.exports = {"main":"Footer_main__3Srxo","fade":"Footer_fade__1SvN6","active":"Footer_active__1XB5c"};